import React from 'react';
import PropTypes from 'prop-types';

import A from 'components/A';
import Avatar from 'components/Avatar';
import Button from 'components/Button';
import H2 from 'components/H2';

import OpportunityMetadata from "../OpportunityMetadata";
import CircleIcon from 'components/CircleIcon';


export default class OpportunityResult extends React.Component {
    static propTypes = {
        allowsRemote: PropTypes.bool.isRequired,
        handleMessageClick: PropTypes.func.isRequired,
        id: PropTypes.number,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        author: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        duration: PropTypes.string,
        startDate: PropTypes.string.isRequired
    };

    render() {
        return (
            <div className="opportunitiesresult">
                <H2><A to={`/opportunity/${this.props.id}`}>{this.props.title}</A></H2>
                <div className="opportunitiesresult-actions">
                    <Button className="profile__action"
                            noStyles
                            onClick={this.props.handleMessageClick.bind(this)}>
                            <span className="profile__action-icon--wrapper">
                                <CircleIcon type="email" />
                            </span>
                    </Button>

                    {/*<Button className="profile__action"
                            noStyles
                            onClick={() => alert('Favorite this freelancer')}>
                        <span className="profile__action-icon--wrapper">
                            <CircleIcon type="heart" />
                        </span>
                    </Button>*/}
                </div>
                <OpportunityMetadata allowsRemote={this.props.allowsRemote} duration={this.props.duration} location={this.props.location ? this.props.location.name : null} startDate={this.props.startDate} />

                <div className="opportunitiesresult-description">
                    <p>{this.props.description}</p>
                </div>
                <div className="opportunitiesresult-author">
                    <A to={`/business/${this.props.author.id}`}>
                        <Avatar imageUrl={this.props.author.profilePicUrl} size="small" /> posted by {this.props.author.name}
                    </A>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Opportunities/components/OpportunityResult/index.js